import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { resolveWebStorage } from '@xemplo/auth-core';

/**
 * Builds the provider's `UserManager` with both storage tiers stated explicitly.
 *
 * `oidc-client-ts` defaults the user to `sessionStorage` but protocol state to
 * `localStorage`, where every abandoned flow's PKCE `code_verifier` survives
 * browser restarts and is readable by any XSS on the origin. State is per-flow
 * and per-tab: `sessionStorage` survives the top-level redirect out to EIMS and
 * back, and same-origin iframes share it, so silent renew still works. Caller
 * overrides win. See FD-3069.
 *
 * Deliberately not `@xemplo/auth-core`'s `createOidcUserManager`: that one
 * asserts a refresh-token-renewable config, which this provider's callers —
 * `automaticSilentRenew: true`, no `offline_access` — do not satisfy.
 */
export function createUserManager(settings: UserManagerSettings): UserManager {
  const store = resolveWebStorage('session');

  return new UserManager({
    ...settings,
    userStore: settings.userStore ?? (store && new WebStorageStateStore({ store })),
    stateStore: settings.stateStore ?? (store && new WebStorageStateStore({ store })),
  });
}
